var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"form-input-element",class:_vm.element.id,attrs:{"placeholder":_vm.placeholder,"id":_vm.element.id}})}
var staticRenderFns = []

export { render, staticRenderFns }